export default __webpack_public_path__ + "static/topmenu02@2x-f7a7d86b928694ae1e55ad69701044ba.png";